import { Resolution } from './Downloading';
import { TargetSettingsAspectRatioEnum } from 'constants/ratioFormats';

export enum TransitionType {
  None = 'none',
  Fade = 'fade',
  WipeDiagonal = 'wipe_diagonal',
  Shape = 'custom_shape'
}

type Sizes = {
  [key in Resolution]: string;
};

type Urls = {
  [key in TargetSettingsAspectRatioEnum]: Sizes;
};

export type Transition = {
  id: string;
  type: TransitionType;
  is_paid: boolean;
  thumbnail_url: string;
  urls?: Urls;
  format?: string;
  preview_url?: string;
  is_used?: boolean;
  name: string;
};

export type Transitions = {
  current?: string;
  list?: Transition[];
};
